
import Vue from 'vue';
import MenuIcon from '@/components/Icons/MenuIcon.vue';
import CloseIcon from '@/components/Icons/CloseIcon.vue';
import { FocusTrap } from 'focus-trap-vue';
import { EventEnum, ModalEnum } from '@/types/events';
import TransitionExpand from '@/components/Transitions/TransitionExpand.vue';
import { settingsHelper } from '@/store/modules/settings';
const settingsHelpers = settingsHelper.mapGetters(['locale']);
export default Vue.extend({
  name: 'BurgerMenu',
  components: {
    TransitionExpand,
    MenuIcon,
    CloseIcon,
    FocusTrap: FocusTrap,
  },
  data() {
    return {
      opened: false,
      isActive: false
    };
  },
  computed: {
    ...settingsHelpers,
    faq() {
      return ModalEnum.Faq;
    },
    isSafe() {
      return ModalEnum.IsSafe;
    },
    openBanking() {
      return ModalEnum.WhatOpenBanking;
    },
    whoAccountScore() {
      return ModalEnum.WhoIsAccountScore;
    },
    aboutAccountScore() {
      return ModalEnum.AboutAccountScore;
    },
    providingYourBankDetails() {
      return ModalEnum.ProvidingYourBankDetails;
    },
    security() {
      return ModalEnum.Security;
    },
    noCreditImpact() {
      return ModalEnum.NoCreditImpact;
    },
    isUK(): boolean {
      return this.locale.current === 'en-GB';
    },
  },
  methods: {
    showModal(m: ModalEnum) {
      this.opened = false;
      this.$bus.$emit(EventEnum.OpenModal, m);
    },
    toggle(e: MouseEvent) {
      this.opened = !this.opened;
      // e.preventDefault();
    },
    clickOutside(e: MouseEvent, eee: any) {
      this.opened = false;
    },
  },
  watch: {
    opened(v) {
      this.$emit('change', v);
      if (this.opened) {
        this.isActive = true;
        setTimeout(() => {          
          document.addEventListener('click', this.clickOutside as any);
        }, 5);
      } else {
        this.isActive = false;
        document.removeEventListener('click', this.clickOutside as any);
      }
    },
  },
  beforeMount() {},
  beforeDestroy() {
    document.removeEventListener('click', this.clickOutside as any);
  },
});
